import { propArray } from '@rxweb/reactive-form-validators';
import { RelationshipContact } from '../../../../../models/agents/relationship-contact';
import { UploadCompanyCategoryType } from '../../../../../models/enums/upload-category-type-enum';
import { BaseModel } from './base.model';

export class IssuerModel extends BaseModel {
  constructor() {
    super();
    this.allowedFiles = [
      UploadCompanyCategoryType.IdentificationDocument,
      UploadCompanyCategoryType.AttorneyLetter
    ];
    this.relationshipContacts = [];
  }

  @propArray(RelationshipContact)
  relationshipContacts: RelationshipContact[];
}
